<template>
  <div class="page">
    <div class="workspace">
      <div class="ws-unit">
        <div class="ws-unit-header ">
          <div>
            <el-button
                    type="primary"
                    size="small"
                    round
                    icon="el-icon-plus"
                    @click="create"
            >添加</el-button>
          </div>
          <div class="ws-unit-toolbar">
            <el-form :inline="true">
              <el-form-item>
                <el-input
                        placeholder="请输入名称关键词"
                        v-model="filter.keyword"
                        clearable
                        @clear="onSearch"
                        class="input-with-select"
                        size="mini"
                >
                  <el-button
                          slot="append"
                          icon="el-icon-search"
                          @click="onSearch"
                  ></el-button>
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-input
                        placeholder="请输入负责人姓名"
                        v-model="filter.director"
                        clearable
                        @clear="onSearch"
                        class="input-with-select"
                        size="mini"
                >
                  <el-button
                          slot="append"
                          icon="el-icon-search"
                          @click="onSearch"
                  ></el-button>
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-select
                        size="mini"
                        placeholder="请选择院系"
                        v-model="filter.college"
                        style="width: 100%"
                        clearable
                        @change="onSearch"
                >
                  <el-option
                          v-for="college in colleges"
                          :key="college"
                          :label="college"
                          :value="college">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="ws-unit-body">
          <achievement-table ref="table" />
        </div>
      </div>
    </div>
    <achievement-form
            @success="onSaveSuccess"
            ref="dialog"
    />
  </div>
</template>

<script>
    import AchievementTable from "./Table";
    import AchievementForm from "./Form";

    export default {
        name: "Product",
        components: {
            AchievementTable,
            AchievementForm
        },
        data: function() {
            return {
                colleges:[
                    '信息与通信工程学院',
                    '电子科学与工程学院（示范性微电子学院）',
                    '材料与能源学院',
                    '机械与电气工程学院',
                    '光电科学与工程学院',
                    '自动化工程学院',
                    '资源与环境学院',
                    '计算机科学与工程学院（网络空间安全学院）',
                    '信息与软件工程学院（示范性软件学院）',
                    '数学科学学院',
                    '物理学院',
                    '生命科学与技术学院',
                    '基础与前沿研究院',
                    '通信抗干扰技术国家级重点实验室',
                    '航空航天学院',
                    '经济与管理学院'
                ],
                filter: {
                    keyword: null,
                    college: null,
                    director: null,
                    field: null
                }
            };
        },
        computed: {
            domainQuery() {
                const query = new window.BaaS.Query();
                query.compare("category", "=", "demand");
                return query;
            }
        },
        methods: {
            create() {
                this.$refs.dialog.show();
            },
            onSearch(){
                this.$refs.table.loadData(1);
            },
            onSaveSuccess() {
                this.$refs.table.loadData();
            }
        }
    };
</script>

<style scoped>
</style>